import Axios from "axios";
import { SETTINGS } from "../properties/ApiProps";

export const EducationRepository = {
  getEducations: (name) => {
    return Axios({
      url: SETTINGS.API_URL + "education/filteredByName",
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        nameFilter: name,
      },
    });
  },
};
